import {createBrowserRouter, Outlet, ScrollRestoration} from "react-router-dom";

// Главные компоненты
import {Header} from './general_components/Header'
import {Footer} from './general_components/Footer'

// Страницы
// Главная
import {IndexPage} from './pages/index'

// Отзывы
import {ReviewsPage} from './pages/reviews'

// Магазин
import {ShopPage} from "./pages/shop";

// Админ панель
import {AdminPage} from "./pages/admin";

function App() {
    return (
        <>
            <Header/>
            <Outlet/>
            <Footer/>
            <ScrollRestoration/>
        </>
    )
}

export const router = createBrowserRouter([{
    path: "",
    element: <App/>,
    children: [{
        // Главная
        index: true,
        element: <IndexPage/>
    }, {
        path: "reviews",
        element: <ReviewsPage/>
    }, {
        path: "shop",
        element: <ShopPage/>
    }, {
        path: "admin",
        element: <AdminPage/>
    }]
}])